import inlineSVG from '@gearset/web-core/scripts/inlineSvg.js';
import eachElement from 'Utils/eachElement.js';
import analytics from 'Scripts/analytics.js';
import calendly from 'Scripts/calendly.js';

import charts from './util/charts.js';


document.addEventListener('DOMContentLoaded', () => {
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, () => {
		document.documentElement.classList.toggle('is-loaded');
	});

	analytics.trackTaggedAnchors();
	calendly.setUpCalendly();

	/* Set up charts */
	charts.setUpCharts({
		/* Work out appropriate chart colors for given section */
		getColors: section => {
			const colors = [];

			/* Which scheme clashes with which color */
			const schemeColors = {
				'has-color-scheme-dark-blue': '#5B6D92',
				'has-color-scheme-red': '#EA6756',
				'has-color-scheme-orange': '#FC935F',
				'has-color-scheme-yellow': '#EFD797',
				'has-color-scheme-blue': '#8AA4DA',
				'has-color-scheme-lilac': '#E1AED0',
				'has-color-scheme-light-grey': '#CFCBC1',
				'has-color-scheme-dark-grey': '#8B897B',
				'has-color-scheme-black': '#515151',
			};

			/* Add all the colours that don't match the current scheme */
			for (const scheme in schemeColors) {
				if (!section?.classList?.contains(scheme)) {
					colors.push(schemeColors[scheme]);
				}
			}

			return colors;
		},
	});

	/* Smooth scrolling for table of contents */
	for (const anchor of document.querySelectorAll('.menu-list a')) {
		anchor.addEventListener('click', function (event) {
			event.preventDefault();

			/* Hide mobile menu */
			document.documentElement.classList.remove('has-contents-active');

			/* Scroll to destination */
			document.querySelector(this.getAttribute('href')).scrollIntoView({
				behavior: 'smooth',
			});

			/* Update hash in URL */
			history.pushState(null, null, this.getAttribute('href'));
		});
	}

	/* Open share drawer */
	eachElement('.is-share-drawer', instance => {
		instance.addEventListener('click', () => {
			if (!instance.classList.contains('is-active')) {
				instance.classList.add('is-active');
			}
		});
	});

	/* Open mobile nav */
	document.querySelector('button.show-contents').addEventListener('click', () => {
		document.documentElement.classList.toggle('has-contents-active');
	});
});
